import React, { useState } from "react";
import SprintItem from "./SprintItem";
import SprintDetails from "./SprintDetails";
import BurnDownChart from "./BurnDownChart";
import { Timestamp } from "firebase/firestore";

function SprintList({ sprints, openSprintBacklogs, chooseSelectedItems, colourBlindMode }) {
    const [isOpenModel, setIsOpenModel] = useState(0);
    const [selectedItem, setSelectedItem] = useState({
        sprintID: "",
        sprintName: "",
        sprintStartDate: Timestamp.fromDate(new Date()),
        sprintEndDate: Timestamp.fromDate(new Date()),
        sprintStatus: "",
        sprintTotalStoryPoint: 0
    });

    const openDetail = (item) => {
        setSelectedItem(item);
        setIsOpenModel(1);
    };
    
    const openChart = (item) => {
        setSelectedItem(item);
        setIsOpenModel(2);
    };

    const closeModal = () => {
        setSelectedItem(null);
        setIsOpenModel(0);
    };

    return (
        <div className="relative h-[86vh] rounded-3xl mr-5 pt-[50px] pb-28 pl-[500px] flex justify-center items-center">
            <div className="bg-[#3D3E44] w-2/5 h-full rounded-[50px] pt-[20px]">
                <span className="text-white font-sans text-3xl ml-[30px]">Sprints</span>
                <div className=" overflow-y-scroll h-[84%] w-[90%] mt-[10px] ml-[30px]">
                    {sprints.map((sprint, index) => (
                        <SprintItem
                            sprint={sprint}
                            openDetail={openDetail}
                            openSprintBacklog={openSprintBacklogs}
                            chooseSelectedItems={chooseSelectedItems}
                            openChart={openChart}
                            colourBlindMode={colourBlindMode}
                        />
                    ))}
                    {isOpenModel === 1 && (
                        <SprintDetails sprint={selectedItem} closeModal={closeModal} />
                    )}
                </div>
            </div>
            <div className="relative mt-[5%] w-[100%] items-center justify-center">
                <BurnDownChart
                    sprint={selectedItem}
                    isOpenModel={isOpenModel}
                    colourBlindMode={colourBlindMode}

                />
            </div>
        </div>
    )
};

export default SprintList;

